<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row justify-content-center">
        <div class="col-xl-10">
          <b-overlay :show="companyLoading" class="rounded" variant="transparent">
            <template #overlay>
              <b-img
                width="100"
                :src="require('@/assets/img/brand/loader.gif')"
                alt=""
              />
            </template>
            <card shadow class="rounded">
              <div slot="header" class="bg-transparent border-0">
                <div class="row align-items-center">
                  <div class="col-1">
                    <base-button
                      type="primary"
                      size="sm"
                      @click="$router.back()"
                      ><i class="ni ni-bold-left"></i
                    ></base-button>
                  </div>
                  <div class="col-8">
                    <h3 class="mb-0">{{ $t("edit_company") }}</h3>
                  </div>
                </div>
              </div>
              <template>
                <createOrUpdate :data="getShowCompany" />
              </template>
            </card>
          </b-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import createOrUpdate from "../../components/Forms/CompanyForm.vue";
export default {
  name: "create_company",
  components: {
    createOrUpdate,
  },
  async mounted() {
    await this.fetchShowCompany(this.$route.params.id);
  },
  methods: {
    ...mapActions({
      fetchShowCompany: "fetchShowCompany",
    }),
  },
  computed: {
    ...mapGetters({
      companyLoading: "companyLoading",
      getShowCompany: "getShowCompany",
    }),
  },
};
</script>
